<!-- 添加访客接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {"parkCode": "2KNTYVWC", "carNo": "粤YGW982", "visitorId": 68},
        responseCode: {
          "data": {}, "message": "业务成功", "resultCode": 0, "status": 1
        }, infoData: {
          explain: "第三方接入系统请求智慧停车开放平台取消某个访客车辆",
          t_url: this.commonUrls.test + "cancelVisitorCarNew",
          p_url: this.commonUrls.prod + "cancelVisitorCarNew",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [

              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {
                info1: 'visitorId',
                info2: '否',
                info3: 'String',
                info4: '访客编号，与车牌号二选一，同时传时优先使用访客编号，使用访客编号时为精确取消，仅使用车牌时取消最新的一次访客'
              },
              {
                info1: 'carNo',
                info2: '否',
                info3: 'String',
                info4: '车牌号，与访客编号二选一，同时传时优先使用访客编号，使用访客编号时为精确取消，仅使用车牌时取消最新的一次访客'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/visitor/cancelVisitorCarNew.vue